import AmioHttpService from '@/services/amio/amio-http.service'

class UtilsService extends AmioHttpService {
  async testApiCall({ url, httpVerb, headers, body, variables }) {
    try {
      const response = await this.requestPost('/utils/test-api-call', {
        url,
        http_verb: httpVerb,
        headers,
        body,
        variables
      })
      return adaptApiCallTestResponse(response.data)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async getDaktelaEmailDetails({ daktelaUrl, accessToken }) {
    try {
      const response = await this.requestPost('/utils/daktela-email-details', {
        daktela_url: daktelaUrl,
        access_token: accessToken
      })
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async getPlainChatIdentity() {
    try {
      const response = await this.requestGet('/utils/plain-chat-identity')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

function adaptApiCallTestResponse(response) {
  return {
    httpStatus: response.http_status,
    body: response.body,
    headers: response.headers,
    message: response.message,
    error: !!response.error
  }
}

export default new UtilsService()
